import React from "react";
import { Modal, Button } from "react-bootstrap";
import DocViewer, {
  PDFRenderer,
  MSDocRenderer,
  PNGRenderer,
  JPGRenderer,
} from "react-doc-viewer";

const DocumentPreview = ({
  setModalShow,
  docs,
  modalShow,
  isGuest,
  setShowResumeUpload,
  fileType,
  preview,
}) => {
  return (
    <>
      <Modal show={modalShow} centered id="showpreview">
        <Modal.Body>
          <div className="preview-uploaded-document">
            {fileType === "gif" ? (
              <iframe title="resume" src={preview} />
            ) : (
              <DocViewer
                documents={docs}
                pluginRenderers={[
                  PDFRenderer,
                  MSDocRenderer,
                  PNGRenderer,
                  JPGRenderer,
                ]}
                style={{
                  width: "700px",
                  height: "700px",
                  textAlign: "center",
                }}
                theme={{
                  primary: "#5296d8",
                  secondary: "#00000099",
                  tertiary: "#5296d899",
                  text_primary: "#ffffff",
                  text_secondary: "#5296d8",
                  text_tertiary: "#00000099",
                  disableThemeScrollbar: false,
                }}
              />
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setModalShow(false);
            }}
          >
            Close
          </Button>
          {isGuest && (
            <Button
              variant="primary"
              onClick={() => {
                setModalShow(false);
                setShowResumeUpload(true);
              }}
            >
              Re-Upload
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DocumentPreview;
